import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {Lib} from "../../../../../libs/Lib";
import {take} from 'rxjs/operators';

const averMediaLabel = 'AVer MediaCenter HD (Windows)';
const powerLabel = 'PowerPoint Viewer (Windows)';
const captureLabel = 'Capture card (Windows)';

interface IBase64Data {
    name: string;
    appName64: string;
    cmdLine64: string;
}

@Component({
    selector: 'app-scene-block-capture',
    templateUrl: './block-external.component.html',
    styleUrls: ['./block-external.component.scss']
})

export class BlockExternalComponent extends BlockBaseComponent {

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        formValues.appName64 = this.getDefaultBase64s(formValues.predefined, formValues)?.appName64;
        formValues.cmdLine64 = this.getDefaultBase64s(formValues.predefined, formValues)?.cmdLine64;
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        this.setUiConfigHide('downloadLink', true);
        this.setUiConfigHide('vdubPath', true);
        this.setUiConfigHide('vdubPath2', true);
        this.setUiConfigHide('associateSomeFile', true);
        this.setUiConfigHide('appName64', true);
        this.setUiConfigHide('cmdLine64', true);
        this.setUiConfigHide('applyFilter', true);
        switch (this.sceneItem.Data[0].ExtApp[0].$.predefined) {
            case 'virtualDub': {
                this.setUiConfigHide('vdubPath', false);
                this.setUiConfigHide('vdubPath2', false);
                this.setUiConfigHide('applyFilter', false);
                this.setFormValue('appName64', this.getDefaultBase64s(captureLabel).appName64);
                this.setFormValue('cmdLine64', this.getDefaultBase64s(captureLabel).cmdLine64);
                break;
            }
            case 'averMediaCenter': {
                this.setUiConfigHide('appName64', false);
                this.setFormValue('appName64', this.getDefaultBase64s(averMediaLabel).appName64);
                this.setFormValue('cmdLine64', this.getDefaultBase64s(averMediaLabel).cmdLine64);

                break;
            }
            case 'powerPoint': {
                this.setUiConfigHide('vdubPath', true);
                this.setUiConfigHide('vdubPath2', true);
                this.setUiConfigHide('appName64', false);
                this.setUiConfigHide('cmdLine64', false);
                this.setUiConfigHide('downloadLink', false);
                this.setUiConfigHide('associateSomeFile', false);
                this.setFormValue('appName64', this.getDefaultBase64s(powerLabel).appName64);
                this.setFormValue('cmdLine64', this.getDefaultBase64s(powerLabel).cmdLine64);

                break;
            }
            case 'custom': {
                this.setUiConfigHide('appName64', false);
                this.setUiConfigHide('cmdLine64', false);
                this.setUiConfigHide('associateSomeFile', false);
                break;
            }
        }
        super.componentStoreUpdates();
    }

    private getDefaultBase64s(predefined, formValues = null): IBase64Data {
        switch (predefined) {
            case averMediaLabel: {
                return {
                    name: 'C:\\Program Files\\AVerMedia\\AVer MediaCenter\\AVer MediaCenter.exe',
                    appName64: 'QzpcUHJvZ3JhbSBGaWxlc1xBVmVyTWVkaWFcQVZlciBNZWRpYUNlbnRlclxBVmVyIE1lZGlhQ2VudGVyLmV4ZQ==',
                    cmdLine64: ''
                };
            }
            case powerLabel: {
                return {
                    name: 'C:\\Program Files\\Microsoft Office\\Office12\\PPTVIEW.EXE',
                    appName64: 'QzpcUHJvZ3JhbSBGaWxlc1xNaWNyb3NvZnQgT2ZmaWNlXE9mZmljZTEyUFBUVklFVy5FWEU=',
                    cmdLine64: Lib.Base64().encode(formValues?.cmdLine64),
                };
            }
            case captureLabel: {
                return {
                    name: 'win32\\VirtualDub\\VirtualDub.exe',
                    appName64: 'd2luMzJcVmlydHVhbER1YlxWaXJ0dWFsRHViLmV4ZQ==',
                    cmdLine64: 'L2NsZWFuQ2FwdHVyZSAgL2FwcGx5RmlsdGVyIGN1YmljIC9jYXBzdGFydA=='
                };
            }
            default: {
                return {
                    name: 'custom',
                    appName64: Lib.Base64().encode(formValues.appName64),
                    cmdLine64: Lib.Base64().encode(formValues.cmdLine64),
                };
            }
        }
    }

    private openAssociateDialog(e) {
        const data: IDialogGetAsset = {mode: "RESOURCE:ALL"};
        const dialogRef = this.dialog.open(DialogGetAssetComponent, {
            height: '90%',
            width: '1200px',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRef.afterClosed()
                .pipe(take(1))
                .subscribe((dialogGetAsset: IDialogGetAsset) => {
                    if (!dialogGetAsset) return;
                    let value;
                    switch (this.sceneItem.Data[0].ExtApp[0].$.predefined) {
                        case 'powerPoint': {
                            value = `/S $File[${dialogGetAsset.selected}]`;
                            break;
                        }
                        case 'custom': {
                            value = `$File[${dialogGetAsset.selected}]`;
                            break;
                        }
                    }
                    this.saveCmdLine64('cmdLine64', value);
                    this.setFormValue('cmdLine64', value);
                })
        );
    }

    saveCmdLine64(key: 'cmdLine64' | 'appName64', i_value) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key,
                value: Lib.Base64().encode(i_value),
                storePath: `Data[0].ExtApp[0].$`
            }]
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.predefined', {}, this.translocoService.getActiveLang()),
                name: "predefined",
                value: "",
                ignoreMissingValue: true,
                options: [
                    {
                        optionsLabel: captureLabel,
                        optionValue: 'virtualDub',
                        optionType: 'text'
                    },
                    {
                        optionsLabel: averMediaLabel,
                        optionValue: 'averMediaCenter',
                        optionType: 'text'
                    },
                    {
                        optionsLabel: powerLabel,
                        optionValue: 'powerPoint',
                        optionType: 'text'
                    },
                    {
                        optionsLabel: 'custom',
                        optionValue: 'custom',
                        optionType: 'text'
                    }
                ],
                storePath: 'Data[0].ExtApp[0].$.predefined'
            },
            {
                type: "button",
                value: this.translocoService.translate('general.associateResource', {}, this.translocoService.getActiveLang()),
                inputType: "standard",
                label: this.translocoService.translate('general.pickFile', {}, this.translocoService.getActiveLang()),
                icon: 'attach_file',
                name: "associateSomeFile",
                callBackEvent: (v) => this.openAssociateDialog(v)
            },
            {
                type: "button",
                value: this.translocoService.translate('general.downloadFile', {}, this.translocoService.getActiveLang()),
                inputType: "standard",
                label: this.translocoService.translate('general.powerPoint', {}, this.translocoService.getActiveLang()),
                icon: 'insert_link',
                name: "downloadLink",
                callBackEvent: (v) => {
                    window.open('http://signage.me/files/powerpointviewer.exe', '_blank');
                }
            },
            {
                type: "input",
                value: this.translocoService.translate('general.filePath', {}, this.translocoService.getActiveLang()),
                label: 'win32\\VirtualDub\\VirtualDub.exe',
                inputType: "label",
                name: "vdubPath"
            },
            {
                type: "input",
                value: '/cleanCapture /applyFilter linear /capstart',
                // label: 'win32\\VirtualDub\\VirtualDub.exe',
                label: this.translocoService.translate('general.commandLineArgs', {}, this.translocoService.getActiveLang()),
                inputType: "textarea",
                disabled: false,
                name: "vdubPath2"
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.appName', {}, this.translocoService.getActiveLang()),
                inputType: "base64",
                restrictChar: 'basic0',
                name: "appName64",
                storePath: 'Data[0].ExtApp[0].$.appName64'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.cmdLine', {}, this.translocoService.getActiveLang()),
                inputType: "base64",
                restrictChar: 'basic0',
                name: "cmdLine64",
                storePath: 'Data[0].ExtApp[0].$.cmdLine64'
            },
            {
                type: "select",
                label: this.translocoService.translate('general.captureFilter', {}, this.translocoService.getActiveLang()),
                name: "applyFilter",
                value: "",
                ignoreMissingValue: true,
                options: [
                    {
                        optionsLabel: 'None',
                        optionValue: 'none',
                        optionType: 'text'
                    },
                    {
                        optionsLabel: 'Linear',
                        optionValue: 'linear',
                        optionType: 'text'
                    },
                    {
                        optionsLabel: 'Cubic',
                        optionValue: 'cubic',
                        optionType: 'text'
                    }
                ],
                storePath: 'Data[0].ExtApp[0].Params.[0].$.applyFilter'
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

